// LearnMore.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ChangePassword } from '../HomeComponents/ChangePassword'; // <--- update the path to where ChangePassword is located
import '../../styles/PagesStyling/LearnMore.css';

const LearnMore = ({
  isLoggedIn,
  setIsLoggedIn,
  userData,
  setUserData,
}) => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  const ElasticInfo = `${process.env.PUBLIC_URL}/assets/logos/elastic-info.svg`;
  const Back = `${process.env.PUBLIC_URL}/assets/logos/back.svg`;
  const WorkManagement = `${process.env.PUBLIC_URL}/assets/logos/work-management.svg`;

  const handleLogout = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/logout`,
        {},
        { withCredentials: true }
      );
      setUserData(null);
      setIsLoggedIn(false);
      setShowDropdown(false);
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="learn-more-page">
      <div className="learn-more-header">
        <button
          className="back-to-dashboard-btn"
          style={{ margin: "0 10px" }}
          onClick={() => navigate("/")}
        >
          <img
            src={Back}
            alt="Back to Dashboard"
            className="workspace-icon"
            title="Back to Dashboard"
          />
        </button>

        <div className="header-column actions" style={{ justifyContent: "flex-start" }}>
          {!isLoggedIn && !userData ? (
            <>{/* login form if needed */}</>
          ) : (
            <>
              <div
                className="user-dropdown"
                onMouseLeave={() => setShowDropdown(false)}
              >
                <button
                  className="user-btn"
                  title="User Control Panel"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  {userData?.FName?.[0]}
                  {userData?.LName?.[0]}
                </button>

                {showDropdown && (
                  <div
                    className="dropdown-menu"
                    style={{
                      right: userData?.Role.includes("Admin")
                        ? "calc(14vh + 30px)"
                        : "calc(7vh + 20px)"
                    }}
                  >
                    <button onClick={() => setShowChangePassword(true)}>
                      Change Password
                    </button>
                    <button onClick={handleLogout}>Log Out</button>
                  </div>
                )}
              </div>

              <button className="user-btn" style={{ marginLeft: "10px" }}>
                <img
                  src={ElasticInfo}
                  alt="Learn More Elastic Search"
                  className="workspace-icon"
                  title="Learn More Elastic Search"
                />
              </button>
            </>
          )}

          {isLoggedIn && userData?.Role.includes("Admin") && (
            <button
              className="workspace-btn"
              title="Admin Control Panel"
              onClick={() => navigate("/admin")}
            >
              <img
                src={WorkManagement}
                alt="Admin Control Panel"
                className="workspace-icon"
              />
            </button>
          )}

          {showChangePassword && (
            <div className="modal-overlay">
              <div className="change-password-modal-content">
                <ChangePassword
                  email={userData?.Email}
                  setShowChangePassword={setShowChangePassword}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <main className="learn-more-main">
        <h1>Live Well Project Explorer Help</h1>

        <h2>What is the Project Explorer?</h2>
        <p>
          Live Well has created our Project Explorer to provide co-ops, educators sponsors, and other team members with easy access to past projects. This creates an efficient, searchable database where anyone—whether you're new to a project or trying to recall details—can quickly find relevant information.
        </p>

        <h2>How does it work?</h2>
        <p>
          The Project Explorer uses a technology called Elasticsearch, a powerful search tool, and a generative AI model.
        </p>
        <p>
          Live Well project data is brought into Elasticsearch and organized by project and sponsor. When you ask a question, the tool finds an answer using only our project data and then the generative AI writes up the answer. This means there are no hallucinations.
        </p>

        <h2>What are the use cases?</h2>
        <p>
          You can ask for summaries of project briefs and descriptions, pull stakeholder quotes, and ask direct questions, e.g., about research findings, themes, methods used, or project team members.
        </p>
        <p><strong>Example:</strong></p>
        <p>
          If you want to know what methods a project used, you could ask:
        </p>
        <p className="example-question">
          <strong>“List all the research methods used for this project.”</strong>
        </p>
        <p>
          You could go deeper by asking for all the research methods and a summary of findings from each method.
        </p>
        <p>
          The Project Explorer will generate a concise summary to save you time, helping you avoid digging through old files and presentations—especially when you're unsure of the original project scope.
        </p>

        <h2>Tips &amp; Tricks</h2>
        <p>
          The way you phrase questions is important! use a robust prompt and be specific in your request. As with any AI tool, the answer is only as good as the question you ask.
        </p>

        <h2>What about security?</h2>
        <p>
          Data security is critical to the work we do and to our sponsors. Elasticsearch's cloud platform is both SOC 2 and HIPAA compliant. You can learn more about Elasticsearch's security and data privacy on their website.
        </p>
        <p>
          In addition, our Project Explorer utilizes OpenAI's GPT-4.1 Nano to generate answers to your. Only the small relevant chunks of a document related to the question (not the full document) are sent to OpenAI. We do not “train the model” and have additional security features built in to the site. If you have any questions, please reach out to our team.
        </p>
      </main>
    </div>
  );
};

export default LearnMore;
